export const NOTIFICATION_STATUS = "NOTIFICATION_STATUS";
export const GETAGAINNOTIFICATION = "GETAGAINNOTIFICATION";
export const GETSAAGAINNOTIFICATION = "GETSAAGAINNOTIFICATION";
export const SELECTED_UNIT_COUNT = "SELECTED_UNIT_COUNT";
export const TOGGLE_UNIT_DRAWER = "TOGGLE_UNIT_DRAWER";
export const CONSTRUCTION_ID_PROJECTS = "CONSTRUCTION_ID_PROJECTS";
export const NEW_UNIT_INFO = "NEW_UNIT_INFO";
export const OLGU_DATA_SEARCH_DESIGN = "OLGU_DATA_SEARCH_DESIGN";
export const SAVE_DASTE_PROFILE_LIST_TYPE_DESIGN =
  "SAVE_DASTE_PROFILE_LIST_TYPE_DESIGN";
export const SAVE_ALL_OLGU_DATA_DESIGN = "SAVE_ALL_OLGU_DATA_DESIGN";
export const ADDONS_INFO = "ADDONS_INFO";
export const CHECK_ADDONS = "CHECK_ADDONS";
export const SELECTED_UNIT_ID = "SELECTED_UNIT_ID";
export const SELECT_TOOL = "SELECT_TOOL";
export const POP_LIST = "POP_LIST";
export const UNIT_INFO = "UNIT_INFO";
export const DRAWER_RESULT = "DRAWER_RESULT";
export const DRAWER_RESET = "DRAWER_RESET";
export const SHOW_UNIT_SIDE_DRAWER = "SHOW_UNIT_SIDE_DRAWER";
export const DESIGNER_BREAK_FRAME = "DESIGNER_BREAK_FRAME";
export const DESIGNER_BREAK_FRAME_ACTION = "DESIGNER_BREAK_FRAME_ACTION";
export const USER_DATA = "USER_DATA";
export const GET_BACK_FROM_DESIGN = "GET_BACK_FROM_DESIGN";
export const ACTIVE_SILENT_DRAWER = "ACTIVE_SILENT_DRAWER";
export const DEACTIVE_SILENT_DRAWER = "DEACTIVE_SILENT_DRAWER";
export const FACTOR_DATA = "FACTOR_DATA";
export const FACTOR_RESULT = "FACTOR_RESULT";
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_SUCCESS_REGISTER = "AUTH_SUCCESS_REGISTER";
export const AUTH_NUMBER = "AUTH_NUMBER";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const SINGIN_TYPE2_ONE = "SINGIN_TYPE2_ONE";
export const SEND_CODE_TOW_FACTOR_SUCCESS = "SEND_CODE_TOW_FACTOR_SUCCESS";
export const SINGIN_TYPE2 = "SINGIN_TYPE2";
export const AUTH_VERIFY_MODEL = "AUTH_VERIFY_MODEL";
export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";
export const SET_SIGN_UP = "SET_SIGN_UP";
export const VERIFY_TYPE = "VERIFY_TYPE";
export const SET_TOKEN_NULL = "SET_TOKEN_NULL";
export const RESET_PASSWORD_VERIFY = "RESET_PASSWORD_VERIFY";
export const SAVE_NUMBER_CODE = "SAVE_NUMBER_CODE";
export const SIGNUP_VERIFY = "SIGNUP_VERIFY";
export const SAVE_USER_FULL_NAME = "SAVE_USER_FULL_NAME";
export const SAVE_USERS_FORGET = "SAVE_USERS_FORGET";
export const ALL_MOSHTARI_LIST = "ALL_MOSHTARI_LIST";
export const USER_SEARCH = "USER_SEARCH";
export const MOSHTARI_SEARCH = "MOSHTARI_SEARCH";
export const FAIL_MOSHTARI_ACTION = "FAIL_MOSHTARI_ACTION";
export const START_MOSHTARI_ACTION = "START_MOSHTARI_ACTION";
export const SUCCESS_MOSHTARI_ACTION = "SUCCESS_MOSHTARI_ACTION";
export const GROUH_MOSHTARI = "GROUH_MOSHTARI";
export const SAVE_ALL_MOSHTARI_DATA = "SAVE_ALL_MOSHTARI_DATA";
export const ALL_GROUH_MOSHTARI = "ALL_GROUH_MOSHTARI";
export const SAVE_COMBO_MOSHTARI = "SAVE_COMBO_MOSHTARI";
export const ACTION_MOSHTARI_RELATION_SHOW_BOX =
  "ACTION_MOSHTARI_RELATION_SHOW_BOX";
export const ACTION_GET_MOSHTARI_RELATION = "ACTION_GET_MOSHTARI_RELATION";
export const ACTION_GROUP_MOSHTARI_RELATION_SHOW_BOX =
  "ACTION_GROUP_MOSHTARI_RELATION_SHOW_BOX";
export const ACTION_GET_GROUP_MOSHTARI_RELATION =
  "ACTION_GET_GROUP_MOSHTARI_RELATION";
export const SUCCESS_OLGU_ACTION = "SUCCESS_OLGU_ACTION";
export const FAIL_OLGU_ACTION = "FAIL_OLGU_ACTION";
export const START_OLGU_ACTION = "START_OLGU_ACTION";
export const SAVE_FRAME_LIST = "SAVE_FRAME_LIST";
export const SAVE_COLOR_LIST = "SAVE_COLOR_LIST";
export const KHADAMAT_SEARCH = "KHADAMAT_SEARCH";
export const SAVE_TORI_LIST = "SAVE_TORI_LIST";
export const SAVE_SHISHE_GROUP_LIST = "SAVE_SHISHE_GROUP_LIST";
export const SAVE_SHISHE_LIST = "SAVE_SHISHE_LIST";
export const SAVE_ALL_OLGU_DATA = "SAVE_ALL_OLGU_DATA";
export const SAVE_DASTE_PROFILE_LIST_TYPE = "SAVE_DASTE_PROFILE_LIST_TYPE";
export const SET_DATA_OLGU_FOR_EDIT = "SET_DATA_OLGU_FOR_EDIT";
export const SELECT_ID_GROUP_GLASS = "SELECT_ID_GROUP_GLASS";
export const SELECT_ID_GROUP_PROFILE_OLGU = "SELECT_ID_GROUP_PROFILE_OLGU";
export const ACTION_OLGU_RELATION_SHOW_BOX = "ACTION_OLGU_RELATION_SHOW_BOX";
export const ACTION_GET_OLGU_RELATION = "ACTION_GET_OLGU_RELATION";
export const ALL_PROJECT_LIST = "ALL_PROJECT_LIST";
export const OLGU_DATA_SEARCH = "OLGU_DATA_SEARCH";
export const GET_OLGU_AGAIN = "GET_OLGU_AGAIN";
export const START_PROJECT_ACTION = "START_PROJECT_ACTION";
export const SUCCESS_PROJECT_ACTION = "SUCCESS_PROJECT_ACTION";
export const FAIL_PROJECT_ACTION = "FAIL_PROJECT_ACTION";
export const ALL_USER_GROUP_LIST = "ALL_USER_GROUP_LIST";
export const COMBO_PROJECT_USER = "COMBO_PROJECT_USER";
export const SUCCESS_SHOW_TOP_IMAGES = "SUCCESS_SHOW_TOP_IMAGES";
export const SHOW_PROJECTS = "SHOW_PROJECTS";
export const SETTIND_TOLID_SUCCESS = "SETTIND_TOLID_SUCCESS";
export const SETTIND_MALI_SUCCESS = "SETTIND_MALI_SUCCESS";
export const SETTIND_DESIGN_SUCCESS = "SETTIND_DESIGN_SUCCESS";
export const FAIL_SHISHE_ACTION = "FAIL_SHISHE_ACTION";
export const SUCCESS_SHISHE_ACTION = "SUCCESS_SHISHE_ACTION";
export const START_SHISHE_ACTION = "START_SHISHE_ACTION";
export const MAHSOOLE_SHISHE_SEARCH = "MAHSOOLE_SHISHE_SEARCH";
export const SAVE_ALL_SPACER = "SAVE_ALL_SPACER";
export const SAVE_INSERT_SPACER = "SAVE_INSERT_SPACER";
export const UPDATE_SPACER_NUM = "UPDATE_SPACER_NUM";
export const UPDATE_EDIT_SPACER = "UPDATE_EDIT_SPACER";
export const UPDATE_DELETE_SPACER = "UPDATE_DELETE_SPACER";
export const SAVE_ALL_SHISHE = "SAVE_ALL_SHISHE";
export const SAVE_INSERT_SHISHE = "SAVE_INSERT_SHISHE";
export const UPDATE_SHISHE_NUM = "UPDATE_SHISHE_NUM";
export const UPDATE_EDIT_SHISHE = "UPDATE_EDIT_SHISHE";
export const UPDATE_DELETE_SHISHE = "UPDATE_DELETE_SHISHE";
export const SAVE_ALL_SHISHE_GROUP = "SAVE_ALL_SHISHE_GROUP";
export const SAVE_INSERT_SHISHE_GROUP = "SAVE_INSERT_SHISHE_GROUP";
export const UPDATE_SHISHE_GROUP_NUM = "UPDATE_SHISHE_GROUP_NUM";
export const UPDATE_EDIT_SHISHE_GROUP = "UPDATE_EDIT_SHISHE_GROUP";
export const UPDATE_DELETE_SHISHE_GROUP = "UPDATE_DELETE_SHISHE_GROUP";
export const SAVE_ALL_MAHSOOLE_SHISHE = "SAVE_ALL_MAHSOOLE_SHISHE";
export const SAVE_SELECT_GROUP_GLASS = "SAVE_SELECT_GROUP_GLASS";
export const SAVE_SELECT_JEDARE = "SAVE_SELECT_JEDARE";
export const SAVE_SELECT_SHISHE = "SAVE_SELECT_SHISHE";
export const SAVE_SELECT_SPACER = "SAVE_SELECT_SPACER";
export const SAVE_EDIT_MAHSOOLE_SHISHE_DATA = "SAVE_EDIT_MAHSOOLE_SHISHE_DATA";
export const SET_PRICE_PRODUCT_GLASS_GROUP = "SET_PRICE_PRODUCT_GLASS_GROUP";
export const SUCCESS_SET_PRICE_PRODUCT_GLASS_GROUP =
  "SUCCESS_SET_PRICE_PRODUCT_GLASS_GROUP";
export const START_SET_PRICE_PRODUCT_GLASS_GROUP =
  "START_SET_PRICE_PRODUCT_GLASS_GROUP";
export const SAVE_ALL_ROKUB = "SAVE_ALL_ROKUB";
export const SAVE_STRUCT = "SAVE_STRUCT";
export const FAIL_ROKUB_ACTION = "FAIL_ROKUB_ACTION";
export const SUCCESS_ROKUB_ACTION = "SUCCESS_ROKUB_ACTION";
export const START_ROKUB_ACTION = "START_ROKUB_ACTION";
export const SUCCESS_ADD_ROKUB = "SUCCESS_ADD_ROKUB";
export const SUCCESS_EDIT_ROKUB = "SUCCESS_EDIT_ROKUB";
export const SUCCESS_DELETE_ROKUB = "SUCCESS_DELETE_ROKUB";
export const ROKOB_SEARCH = "ROKOB_SEARCH";
export const START_TORI_ACTION = "START_TORI_ACTION";
export const FAIL_TORI_ACTION = "FAIL_TORI_ACTION";
export const SUCCESS_TORI_ACTION = "SUCCESS_TORI_ACTION";
export const SAVE_ALL_TORI = "SAVE_ALL_TORI";
export const SUCCESS_ADD_TORU = "SUCCESS_ADD_TORU";
export const SUCCESS_DELETE_TORI = "SUCCESS_DELETE_TORI";
export const SUCCESS_DISABLE_TORI = "SUCCESS_DISABLE_TORI";
export const SUCCESS_EDIT_TORI = "SUCCESS_EDIT_TORI";
export const ACTION_GET_RELATION_Net = "ACTION_GET_RELATION_Net";
export const TORI_SEARCH = "TORI_SEARCH";
export const SAVE_ALL_KHEDMAT = "SAVE_ALL_KHEDMAT";
export const SUCCESS_KHEDMAT_ACTION = "SUCCESS_KHEDMAT_ACTION";
export const START_KHEDMAT_ACTION = "START_KHEDMAT_ACTION";
export const FAIL_KHEDMAT_ACTION = "FAIL_KHEDMAT_ACTION";
export const ACTION_WARNING_KHEDMAT = "ACTION_WARNING_KHEDMAT";
export const CLOSE_WARNING_KHEDMAT = "CLOSE_WARNING_KHEDMAT";
export const ALERT_KHEDMAT = "ALERT_KHEDMAT";
export const CLOSE_ALERT_KHEDMAT = "CLOSE_ALERT_TORI";
export const SAVE_ALL_KHEDMATSYS = "SAVE_ALL_KHEDMATSYS";
export const SUCCESS_DELETE_KHADAMAT = "SUCCESS_DELETE_KHADAMAT";
export const SUCCESS_DISABLE_KHEDMAT = "SUCCESS_DISABLE_KHEDMAT";
export const SUCCESS_ADD_KHADAMAT = "SUCCESS_ADD_KHADAMAT";
export const SAVE_ALL_FOM_MASTIC = "SAVE_ALL_FOM_MASTIC";
export const SUCCESS_FOM_MASTIC_ACTION = "SUCCESS_FOM_MASTIC_ACTION";
export const FAIL_FOM_MASTIC_ACTION = "FAIL_FOM_MASTIC_ACTION";
export const START_FOM_MASTIC_ACTION = "START_FOM_MASTIC_ACTION";
export const SUCCESS_DELETE_FOM_MASTIK = "SUCCESS_DELETE_FOM_MASTIK";
export const FOM_MASTIC_SEARCH = "FOM_MASTIC_SEARCH";
export const START_PROFILE_ACTION = "START_PROFILE_ACTION";
export const FAIL_PROFILE_ACTION = "FAIL_PROFILE_ACTION";
export const SUCCESS_PROFILE_ACTION = "SUCCESS_PROFILE_ACTION";
export const SAVE_DASTE_PROFILE_LIST = "SAVE_DASTE_PROFILE_LIST";
export const SAVE_TYPE_COLOR_LIST = "SAVE_TYPE_COLOR_LIST";
export const SAVE_PRICE_PROFILE = "SAVE_PRICE_PROFILE";
export const PROFILE_COUNTRY = "PROFILE_COUNTRY";
export const UPDATE_PROFILE_COLUMN = "UPDATE_PROFILE_COLUMN";
export const SERI_PROFILE_TBL_DATA = "SERI_PROFILE_TBL_DATA";
export const SAVE_COLORS = "SAVE_COLORS";
export const IS_SETTING = "IS_SETTING";
export const CHANGE_DISABLE = "CHANGE_DISABLE";
export const SAVE_TYPES = "SAVE_TYPES";
export const SAVE_SELECT_COLOR = "SAVE_SELECT_COLOR";
export const SELECT_DASTE_PROFILE_KEY = "SELECT_DASTE_PROFILE_KEY";
export const SAVE_DASTE_PROFILE_RELATION = "SAVE_DASTE_PROFILE_RELATION";
export const NULL_DASTE_PROFILE_RELATION = "NULL_DASTE_PROFILE_RELATION";
export const SAVE_COLOR_RELATION = "SAVE_COLOR_RELATION";
export const NULL_COLOR_RELATION = "NULL_COLOR_RELATION";
export const SAVE_TYPE_RELATION = "SAVE_TYPE_RELATION";
export const NULL_TYPE_RELATION = "NULL_TYPE_RELATION";
export const SAVE_FIXER_DATA = "SAVE_FIXER_DATA";
export const SAVE_LASTIK_DATA = "SAVE_LASTIK_DATA";
export const SAVE_KASRI_BORESH_DATA = "SAVE_KASRI_BORESH_DATA";
export const SEVE_TYPE_COLOR_VALUE = "SEVE_TYPE_COLOR_VALUE";
export const SAVE_ALL_COLORS = "SAVE_ALL_COLORS";
export const GET_ALL_TYPE_AND_COLOR_START = "GET_ALL_TYPE_AND_COLOR_START";
export const GET_ALL_TYPE_AND_COLOR_SUCCESS = "GET_ALL_TYPE_AND_COLOR_SUCCESS";
export const FILTER_TYPE_ACTION = "FILTER_TYPE_ACTION";
export const SUCCESS_ADD_TYPE_COLOR = "SUCCESS_ADD_TYPE_COLOR";
export const SUCCESS_ADD_COLOR = "SUCCESS_ADD_COLOR";
export const GET_ALL_TYPE_AND_COLOR = "GET_ALL_TYPE_AND_COLOR";
export const ACTION_CHANGE_JENSE = "ACTION_CHANGE_JENSE";
export const START_DELETE_COLOR = "START_DELETE_COLOR";
export const FAILE_DELETE_COLOR = "FAILE_DELETE_COLOR";
export const SUCCESS_DELETE_COLOR = "SUCCESS_DELETE_COLOR";
export const SUCCESS_DELETE_TYPE_COLOR = "SUCCESS_DELETE_TYPE_COLOR";
export const START_YARAGH_ACTION = "START_YARAGH_ACTION";
export const FAIL_YARAGH_ACTION = "FAIL_YARAGH_ACTION";
export const SUCCESS_YARAGH_ACTION = "SUCCESS_YARAGH_ACTION";
export const SAVE_BRAND_YARAGH_LIST = "SAVE_BRAND_YARAGH_LIST";
export const SAVE_BAZSHO_LIST = "SAVE_BAZSHO_LIST";
export const SAVE_HALAT_LIST = "SAVE_HALAT_LIST";
export const SAVE_ARSHIV_BRAND_DATA = "SAVE_ARSHIV_BRAND_DATA";
export const SAVE_YARAGH_COUNTRY = "SAVE_YARAGH_COUNTRY";
export const SELECT_BRAND_YARAGH = "SELECT_BRAND_YARAGH";
export const SAVE_MAHDOODE_DATA = "SAVE_MAHDOODE_DATA";
export const SAVE_YARAGH_TBL_DATA = "SAVE_YARAGH_TBL_DATA";
export const SAVE_BAZSHO_DATA = "SAVE_BAZSHO_DATA";
export const DELETE_BAZSHO_REDUX = "DELETE_BAZSHO_REDUX";
export const DELETE_MAHDOODE_REDUX = "DELETE_MAHDOODE_REDUX";
export const SAVE_MAHDOODEFANI_DATA = "SAVE_MAHDOODEFANI_DATA";
export const SAVENEWSTUFF = "SAVENEWSTUFF";
export const SAVENEWSTUFF_ROK = "SAVENEWSTUFF_ROK";
export const ACTION_WARNING_TORI = "ACTION_WARNING_TORI";
export const CLOSE_WARNING_TORI = "CLOSE_WARNING_TORI";
export const SELECT_BAZSHO = "SELECT_BAZSHO";
export const ALERT_TORI = "ALERT_TORI";
export const CLOSE_ALERT_TORI = "CLOSE_ALERT_TORI";
export const ACTION_WARNING_SHISHE = "ACTION_WARNING_SHISHE";
export const CLOSE_WARNING_SHISHE = "CLOSE_WARNING_SHISHE";
export const ACTION_WARNING_SPACER = "ACTION_WARNING_SPACER";
export const CLOSE_WARNING_SPACER = "CLOSE_WARNING_SPACER";
export const ACTION_NET_RELATION_SHOW_BOX = "ACTION_NET_RELATION_SHOW_BOX";
export const ACTION_GET_NET_RELATION = "ACTION_GET_NET_RELATION";
export const ACTION_FOM_RELATION_SHOW_BOX = "ACTION_FOM_RELATION_SHOW_BOX";
export const ACTION_GET_FOM_RELATION = "ACTION_GET_FOM_RELATION";
export const ACTION_KHADAMAT_RELATION_SHOW_BOX =
  "ACTION_KHADAMAT_RELATION_SHOW_BOX";
export const ACTION_GET_KHADAMAT_RELATION = "ACTION_GET_KHADAMAT_RELATION";
export const ACTION_ROKOB_RELATION_SHOW_BOX = "ACTION_ROKOB_RELATION_SHOW_BOX";
export const ACTION_GET_ROKOB_RELATION = "ACTION_GET_ROKOB_RELATION";
export const ACTION_MAHSOOLE_SHISHE_RELATION_SHOW_BOX =
  "ACTION_MAHSOOLE_SHISHE_RELATION_SHOW_BOX";
export const ACTION_GET_MAHSOOLE_SHISHE_RELATION =
  "ACTION_GET_MAHSOOLE_SHISHE_RELATION";
export const ACTION_SHISHE_RELATION_SHOW_BOX =
  "ACTION_SHISHE_RELATION_SHOW_BOX";
export const ACTION_GET_SHISHE_RELATION = "ACTION_GET_SHISHE_RELATION";
export const ACTION_SHISHE_GROUP_RELATION_SHOW_BOX =
  "ACTION_SHISHE_GROUP_RELATION_SHOW_BOX";
export const ACTION_GET_SHISHE_GROUP_RELATION =
  "ACTION_GET_SHISHE_GROUP_RELATION";
export const ACTION_SPACER_RELATION_SHOW_BOX =
  "ACTION_SPACER_RELATION_SHOW_BOX";
export const ACTION_GET_SPACER_RELATION = "ACTION_GET_SPACER_RELATION";
export const ACTION_GET_DASTE_PROFILE_RELATION =
  "ACTION_GET_DASTE_PROFILE_RELATION";
export const ACTION_DASTE_PROFILE_RELATION_SHOW_BOX =
  "ACTION_DASTE_PROFILE_RELATION_SHOW_BOX";
export const ACTION_COLOR_RELATION_SHOW_BOX = "ACTION_COLOR_RELATION_SHOW_BOX";
export const ACTION_GET_COLOR_PROFILE_RELATION =
  "ACTION_GET_COLOR_PROFILE_RELATION";
export const ACTION_TYPE_RELATION_SHOW_BOX = "ACTION_TYPE_RELATION_SHOW_BOX";
export const ACTION_GET_TYPE_PROFILE_RELATION =
  "ACTION_GET_TYPE_PROFILE_RELATION";
export const ACTION_BRAND_YARAGH_RELATION_SHOW_BOX =
  "ACTION_BRAND_YARAGH_RELATION_SHOW_BOX";
export const ACTION_GET_BRAND_YARAGH_RELATION =
  "ACTION_GET_BRAND_YARAGH_RELATION";
export const ACTION_BAZSHO_YARAGH_RELATION_SHOW_BOX =
  "ACTION_BAZSHO_YARAGH_RELATION_SHOW_BOX";
export const ACTION_GET_BAZSHO_YARAGH_RELATION =
  "ACTION_GET_BAZSHO_YARAGH_RELATION";
export const SUCCESS_FACTOR_ACTION = "SUCCESS_FACTOR_ACTION";
export const FILL_FACTOR_UNIT_LIST = "FILL_FACTOR_UNIT_LIST";
export const SUCCESS_CALC_PRICE__FACTOR_ACTION =
  "SUCCESS_CALC_PRICE__FACTOR_ACTION";
export const SUCCESS_PRINT_FACTOR_ACTION = "SUCCESS_PRINT_FACTOR_ACTION";
export const SUCCESS_SAVE_FACTOR_ACTION = "SUCCESS_SAVE_FACTOR_ACTION";
export const SELECT_USER_GROUP_DATA = "SELECT_USER_GROUP_DATA";
export const GET_GROUP_PRICE_USER = "GET_GROUP_PRICE_USER";
export const ALL_GROUP_USER_DATA = "ALL_GROUP_USER_DATA";
export const NAME_USER_DEFAULT = "NAME_USER_DEFAULT";
export const ACTION_GET_GROUP_USERS_RELATION =
  "ACTION_GET_GROUP_USERS_RELATION";
export const ACTION_GET_COMBO_STYPE_PANEL = "ACTION_GET_COMBO_STYPE_PANEL";
export const ACTION_GET_GROUP_MODEL_FACTOR = "ACTION_GET_GROUP_MODEL_FACTOR";
export const FINISH_UNIT_STR = "FINISH_UNIT_STR";
export const CHANGE_ID_UNIT = "CHANGE_ID_UNIT";
export const CHANGE_INIT_TEMPLATE = "CHANGE_INIT_TEMPLATE";
export const SAVE_SITTING_UNIT = "SAVE_SITTING_UNIT";
export const SAVE_THUMBNAIL_IMAGE = "SAVE_THUMBNAIL_IMAGE";
export const SAVE_IMAGE = "SAVE_IMAGE";
export const SAVE_B = "SAVE_B";
export const SAVE_C = "SAVE_C";
export const SAVE_M = "SAVE_M";
export const SAVE_U = "SAVE_U";
export const SAVE_N = "SAVE_N";
export const SAVE_ROKOB = "SAVE_ROKOB";
export const SAVE_CONSUMABLE = "SAVE_CONSUMABLE";
export const SAVE_SCALE = "SAVE_SCALE";
export const SAVE_WIDTH = "SAVE_WIDTH";
export const SAVE_HEIGHT = "SAVE_HEIGHT";
export const SAVE_LEN_FOAM = "SAVE_LEN_FOAM";
export const SAVE_MOLION_LIST = "SAVE_MOLION_LIST";
export const SAVE_OVERHANG_LIST = "SAVE_OVERHANG_LIST";
export const SAVE_MOLION_FRAME_LIST = "SAVE_MOLION_FRAME_LIST";
export const SAVE_SASH_BAR_LIST = "SAVE_SASH_BAR_LIST";
export const SAVE_MOLION_LIST_RAIL = "SAVE_MOLION_LIST_RAIL";
export const SAVE_INTERLOCK_LIST = "SAVE_INTERLOCK_LIST";
export const SAVE_ZEHVAR_BARN_GIR = "SAVE_ZEHVAR_BARN_GIR";
export const SAVE_SASH_LIST = "SAVE_SASH_LIST";
export const SAVE_COUPLE_LIST = "SAVE_COUPLE_LIST";
export const SAVE_GLASS_SHAPE_LIST = "SAVE_GLASS_SHAPE_LIST";
export const SAVE_PANEL_SHAPE_LIST = "SAVE_PANEL_SHAPE_LIST";
export const SAVE_NET_SHAPE_LIST = "SAVE_NET_SHAPE_LIST";
export const SAVE_POP_SHAPE_LIST = "SAVE_POP_SHAPE_LIST";
export const SAVE_GLASS_SHAPE_DETAIL_LIST = "SAVE_GLASS_SHAPE_DETAIL_LIST";
export const SAVE_PANEL_SHAPE_DETAIL_LIST = "SAVE_PANEL_SHAPE_DETAIL_LIST";
export const SAVE_NET_SHAPE_DETAIL_LIST = "SAVE_NET_SHAPE_DETAIL_LIST";
export const SAVE_POP_SHAPE_DETAIL_LIST = "SAVE_POP_SHAPE_DETAIL_LIST";
export const START_SAVE_DESIGNED_UNIT = "START_SAVE_DESIGNED_UNIT";
export const END_SAVE_DESIGNED_UNIT = "END_SAVE_DESIGNED_UNIT";
export const SAVE_CONECTOR_SASH_LIST = "SAVE_CONECTOR_SASH_LIST";
export const SAVE_UNIT_CONTROL = "SAVE_UNIT_CONTROL";
export const SAVE_ALL_POP_WITH_BRAND = "SAVE_ALL_POP_WITH_BRAND";
export const SAVE_SIZE_SASH = "SAVE_SIZE_SASH";
export const DRAWER_SET_AKARDEONI = "DRAWER_SET_AKARDEONI";
export const SAVE_T = "SAVE_T";
export const OPEN_RIGHT_CLICK = "OPEN_RIGHT_CLICK";
export const CLOSE_RIGHT_CLICK = "CLOSE_RIGHT_CLICK";
export const SAVE_SASH_JSON = "SAVE_SASH_JSON";
export const SAVE_FRAME_JSON = "SAVE_FRAME_JSON";
export const SAVE_ASTANE_JSON = "SAVE_ASTANE_JSON";
export const SAVE_MOLION_JSON = "SAVE_MOLION_JSON";
export const SAVE_ZEHVAR_JSON = "SAVE_ZEHVAR_JSON";
export const SAVE_KOPL_JSON = "SAVE_KOPL_JSON";
export const SAVE_SHISHE_JSON = "SAVE_SHISHE_JSON";
export const SAVE_BRAND_BAZSHO_JSON = "SAVE_BRAND_BAZSHO_JSON";
export const SAVE_TOORI_JSON = "SAVE_TOORI_JSON";
export const SAVE_PANEL_JSON = "SAVE_PANEL_JSON";
export const SET_IDUNIT_ZERO = "SET_IDUNIT_ZERO";
export const LOAD_ROKOB = "LOAD_ROKOB";
export const LOAD_CHECK_ROKOB = "LOAD_CHECK_ROKOB";
export const SELECT_ROKOB_USER = "SELECT_ROKOB_USER";
export const GET_ROKOB_UNIT = "GET_ROKOB_UNIT";
export const LOAD_ASTANEH = "LOAD_ASTANEH";
export const ASTANEH_CLICK = "ASTANEH_CLICK";
export const CALL_STATE_TS = "CALL_STATE_TS";
export const GET_STATE_TS = "GET_STATE_TS";
export const GET_ASTANEH_UNIT = "GET_ASTANEH_UNIT";
export const LOAD_PAKHOR = "LOAD_PAKHOR";
export const GET_PAKHOR_UNIT = "GET_PAKHOR_UNIT";
export const CALL_STATE_OF_PAKHOR = "CALL_STATE_OF_PAKHOR";
export const GET_STATE_PAKHOR = "GET_STATE_PAKHOR";
export const PAKHOR_CLICK = "PAKHOR_CLICK";
export const CALL_STATE_ERTEFA = "CALL_STATE_ERTEFA";
export const GET_STATE_ERTEFA = "GET_STATE_ERTEFA";
export const ERTEFA_CLICK = "ERTEFA_CLICK";
export const LOAD_ERTEFA = "LOAD_ERTEFA";
export const GET_ERTEFA_UNIT = "GET_ERTEFA_UNIT";
export const GET_TEMPLATE_CHANGE_STYLE = "GET_TEMPLATE_CHANGE_STYLE";
export const GET_INFO_TEMPLATE_CHANGE_STYLE = "GET_INFO_TEMPLATE_CHANGE_STYLE";
export const SET_GROUP_BASE_STYLE = "SET_GROUP_BASE_STYLE";
export const STRUCT_TOOLS_LOLAEE = "STRUCT_TOOLS_LOLAEE";
export const GET_FOM_MASTIK_COMBO = "GET_FOM_MASTIK_COMBO";
export const SET_ID_UNIT_ACTIVE_WIZARD = "SET_ID_UNIT_ACTIVE_WIZARD";
export const GET_COMBO_TEMPLATE_UNIT_WIZARD = "GET_COMBO_TEMPLATE_UNIT_WIZARD";
export const GET_COMBO_All_GLass_UNIT_WIZARD =
  "GET_COMBO_All_GLass_UNIT_WIZARD";
export const GET_REBUILD_UNIT_WIZARD_CHANGE = "GET_REBUILD_UNIT_WIZARD_CHANGE";
export const SAVE_UNIT_CONTROL_WIZARD = "SAVE_UNIT_CONTROL_WIZARD";
export const SAVE_IMAGE_WIZARD = "SAVE_IMAGE_WIZARD";
export const SET_STEP_WIZARD = "SET_STEP_WIZARD";
export const SAVE_OLGU_DATA = "SAVE_OLGU_DATA";
export const CHANGE_UNIT_NAME = "CHANGE_UNIT_NAME";
export const CHANGE_MAHALE_NASBE_UNIT = "CHANGE_MAHALE_NASBE_UNIT";
export const CHANGE_NUMBER_OF_UNIT = "CHANGE_NUMBER_OF_UNIT";
export const CHANGE_ARZ_BADKHOR = "CHANGE_ARZ_BADKHOR";
export const CHANGE_ERTEFA_BADKHOR = "CHANGE_ERTEFA_BADKHOR";
export const CHECK_UNIT = "CHECK_UNIT";
export const SAVE_W_H = "SAVE_W_H";
export const SELECT_OLGU = "SELECT_OLGU";
export const NEW_UNIT_SUCCESS = "NEW_UNIT_SUCCESS";
export const Default_Name_OF_UNIT = "Default_Name_OF_UNIT";
export const SET_ID_TEMPLATE_NULL = "SET_ID_TEMPLATE_NULL";
export const CHANGE_ARZ_Wizard = "CHANGE_ARZ_Wizard";
export const CHANGE_ERTEFA_Wizard = "CHANGE_ERTEFA_Wizard";
export const SELECT_GLASS_UNIT_WIZARD = "SELECT_GLASS_UNIT_WIZARD";
export const GET_INFO_UINT_UPDATE_WIZARD = "GET_INFO_UINT_UPDATE_WIZARD";
export const CHECK_UNIT_SAVE = "CHECK_UNIT_SAVE";
export const UNIT_LIST_WITH_IMG = "UNIT_LIST_WITH_IMG";
export const RE_BUILD_UNIT = "RE_BUILD_UNIT";
export const UNIT_CHECKED_CONTROL = "UNIT_CHECKED_CONTROL";
export const ADD_UNIT_TO_UNITBAR = "ADD_UNIT_TO_UNITBAR";
export const CHANGE_UNIT_IMAGE_UNITBAR = "CHANGE_UNIT_IMAGE_UNITBAR";
export const CLEAR_CHECKED_ARR = "CLEAR_CHECKED_ARR";
export const UPDATE_SIZE_UNIT = "UPDATE_SIZE_UNIT";
export const CHECK_ALL_UNIT = "CHECK_ALL_UNIT";
export const SELECTED_DASTE_PROFILE = "SELECTED_DASTE_PROFILE";
export const SELECTED_TYPE_COLOR = "SELECTED_TYPE_COLOR";
export const SAVE_DASTE_PROFILE_LIST_WITH_TYPE_STRUCT =
  "SAVE_DASTE_PROFILE_LIST_WITH_TYPE_STRUCT";
export const SAVE_TYPE_COLOR_LIST_OLGU = "SAVE_TYPE_COLOR_LIST_OLGU";
export const SAVE_BRAND_YARAGH_LIST_OLGU = "SAVE_BRAND_YARAGH_LIST_OLGU";
export const GET_NET_RELATION = "GET_NET_RELATION";
export const MAHDOODE_SEARCH = "MAHDOODE_SEARCH";
export const EDIT_GLASS_DETAIL = "EDIT_GLASS_DETAIL";
export const ALL_CUSTOMERS = "ALL_CUSTOMERS";
export const SELECTED_USER = "SELECTED_USER";
export const SELECTED_CUSTOMER_ADMIN = "SELECTED_CUSTOMER_ADMIN";
export const SELECTED_PROJECT = "SELECTED_PROJECT";
export const SELECTED_CUSTOMER = "SELECTED_CUSTOMER";
export const PROJECT_BUILD_INFO_SUCCESS = "PROJECT_BUILD_INFO_SUCCESS";
export const PROJECT_SEARCH = "PROJECT_SEARCH";
export const ALL_CUSTOMER_LIST_ADMIN = "ALL_CUSTOMER_LIST_ADMIN";
export const CONSTRUCTION_RESULT = "CONSTRUCTION_RESULT";
export const CONSTRUCTION_SENDER = "CONSTRUCTION_SENDER";
export const DESIGN_UNIT_LIST = "DESIGN_UNIT_LIST";
export const DESIGN_UNIT_LIST_LAZY = "DESIGN_UNIT_LIST_LAZY";
export const DESIGN_UNIT_LIST_RESET = "DESIGN_UNIT_LIST_RESET";
export const DESIGN_RESCALE = "DESIGN_RESCALE";
export const DESIGN_OPENONEUNIT = "DESIGN_OPENONEUNIT";
export const CHANGE_FILTERS = "CHANGE_FILTERS";
export const GLASS_COLOR_LIST = "GLASS_COLOR_LIST";
export const FACTOR_SETTING = "FACTOR_SETTING";
export const SAVE_ALL_CONTRACT = "SAVE_ALL_CONTRACT";
export const EDIT_DATA_SELECTED = "EDIT_DATA_SELECTED";
export const SAVE_TABLE_DATA = "SAVE_TABLE_DATA";
export const SELECT_UNITS = "SELECT_UNITS";
export const BENEFIT_DATA = "BENEFIT_DATA";
export const SAVE_INFO_FACTOR_CONTRACT = "SAVE_INFO_FACTOR_CONTRACT";
export const SAVE_DELETE_NOTIFICATION = "SAVE_DELETE_NOTIFICATION";
export const SELECTEDPROFILETYPE = "SELECTEDPROFILETYPE";
export const CAL_FACTOR_PRICE = "CAL_FACTOR_PRICE";
export const RTL_LAYOUT = "RTL_LAYOUT";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_PRECISION = "SET_PRECISION";
export const LOCK_SYSTEM = "LOCK_SYSTEM";
export const UNLOCK_SYSTEM = "UNLOCK_SYSTEM";
export const SET_MENU_DRAWER = "SET_MENU_DRAWER";
export const SEARCHPROFILECATEGORY = "SEARCHPROFILECATEGORY";
export const SEARCHPROFILETYPECOLOR = "SEARCHPROFILETYPECOLOR";
export const SEARCHBRANDFITTING = "SEARCHBRANDFITTING";
export const SEARCHPOP = "SEARCHPOP";
export const GETAGAINTICKET = "GETAGAINTICKET";
//**************************************** SUPER-ADMIN ****************************************
export const RESETPAGINATION = "RESETPAGINATION";
export const ALLGROUPAGENTS = "ALLGROUPAGENTS";
export const ACTIVEPERIODS = "ACTIVEPERIODS";
export const SERVICECOMBO = "SERVICECOMBO";
export const PRODUCTCOMBO = "PRODUCTCOMBO";
export const FACTORCOMBO = "FACTORCOMBO";
export const PRICESUPERVISOR = "PRICESUPERVISOR";
export const GETAGAINPRICESUPERVISOR = "GETAGAINPRICESUPERVISOR";
export const PRICESERVICE = "PRICESERVICE";
export const GETAGAINPRICESERVICE = "GETAGAINPRICESERVICE";
export const PRICEPRODUCT = "PRICEPRODUCT";
export const GETAGAINPRICEPRODUCT = "GETAGAINPRICEPRODUCT";
export const PRICEFACTOR = "PRICEFACTOR";
export const GETAGAINPRICEFACTOR = "GETAGAINPRICEFACTOR";
export const PRICEPERIOD = "PRICEPERIOD";
export const GETAGAINPRICEPERIOD = "GETAGAINPRICEPERIOD";
export const ACCALLGROUP = "ACCALLGROUP";
export const ACCFINANCIAL = "ACCFINANCIAL";
export const ACCHISTORYINCTIME = "ACCHISTORYINCTIME";
export const DEFAULTPANEL = "DEFAULTPANEL";
export const GETAGAINDEFAULTPANEL = "GETAGAINDEFAULTPANEL";
export const DEFAULTCHARGE = "DEFAULTCHARGE";
export const GETAGAINDEFAULTCHARGE = "GETAGAINDEFAULTCHARGE";
export const CREDITMETHOD = "CREDITMETHOD";
export const CREDITTYPE = "CREDITTYPE";
export const MANUALCREDIT = "MANUALCREDIT";
export const DISCOUNTCARD = "DISCOUNTCARD";
export const GETAGAINDISCOUNTCARD = "GETAGAINDISCOUNTCARD";
export const DISCOUNTCARDSTYPE = "DISCOUNTCARDSTYPE";
export const DISCOUNTCARDREFRENCE = "DISCOUNTCARDREFRENCE";
export const TRANSFER = "TRANSFER";
export const GETGROUPAGENT = "GETGROUPAGENT"; // not use
export const GETAGAINSATICKET = "GETAGAINSATICKET";
export const SITEVALIDATION = "SITEVALIDATION";
//**************************************** SHOP ****************************************
export const GROUPTEMPLATELIST = "GROUPTEMPLATELIST";
export const SETTINGPROJECTS = "SETTINGPROJECTS";
export const SETTINGSELECTEDPROJECT = "SETTINGSELECTEDPROJECT";
export const SELECTEDPROJECTUNITS = "SELECTEDPROJECTUNITS";
export const SETTINGGLASSES = "SETTINGGLASSES";
export const REGET = "REGET";
